import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterRegisteredDocumentView.
 * @extends JetView
 */
export default class FilterRegisteredDocumentView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for selecting document type
                            name: 'Type',
                            id: 'Type',
                            label: _('Tipo'),
                            labelPosition: 'top',
                            placeholder: _('Tipo'),
                        },
                        {
                            view: 'text', // Input for user name
                            name: 'Name',
                            label: "<span class='icon-user'></span>" + _('Nombre'),
                            labelPosition: 'top',
                            placeholder: _('Nombre'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByUser',
                        },
                        {
                            view: 'richselect', // Dropdown for activation status
                            name: 'IsActivate',
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: '',
                            options: [
                                { id: '0', value: _('Todos') },
                                { id: 'A', value: _('Activo') },
                                { id: 'I', value: _('Inactivo') },
                            ],
                        },
                        {
                            view: 'text', // Input for login
                            name: 'Login',
                            label: _('Login'),
                            labelPosition: 'top',
                            placeholder: _('Login'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByUser',
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for route
                            name: 'Route',
                            label: _('Ruta'),
                            labelPosition: 'top',
                            placeholder: _('Ruta'),
                        },
                        {
                            view: 'text', // Input for version
                            name: 'Version',
                            label: _('Versión'),
                            labelPosition: 'top',
                            placeholder: _('Versión'),
                        },
                        {
                            view: 'text', // Datepicker for selecting date range
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    width: 100,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    width: 110,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('registeredDocument:filter', [
                            filterdata, // Trigger filter event with form data
                        ]);
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Clear button for popup
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').clear(); // Clears the popup form
                    },
                },
                {
                    view: 'button', // Consult button for popup
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get popup form values
                        this.app.callEvent('registeredDocument:filter', [
                            filterdata, // Trigger filter event with popup data
                        ]);
                        $$('filterPopup').hide(); // Hide the popup
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Popup title
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion and buttons in popup
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and fetches data for the document types.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type for the request
                })
                .post(
                    devConfig.geturlApi() + 'RegisteredDocument/TypeDocument', // API endpoint for document types
                    '',
                    {
                        error: function (text, data, XmlHttpRequest) {
                            webix.message(_('Error! ')); // Show error message
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var resp = JSON.parse(text); // Parse response
                            $$('Type').define('options', resp.Data); // Define options for the Type dropdown
                            $$('Type').refresh(); // Refresh the dropdown
                        },
                    },
                );
        });
    }
}

// FILE DOCUMENTED
